import { takeLatest, put, select } from 'redux-saga/effects';

import history from '../../../history';

import {
  setRouterPreviousPath,
  setRouterPreventRedirect,
  setInvitation,
} from './actions';
import { authInitSuccess, logInSuccess, logOut } from '../auth/actions';
import { selectRouter } from './selectors';

function* logout() {
  const { preventRedirect } = yield select(selectRouter);

  yield put(setRouterPreviousPath(''));

  yield put(setInvitation(null));

  if (!preventRedirect) {
    history.replace('/pages/login');
    yield put(setRouterPreventRedirect(false));
  }

  if (window.hdlh) {
    window.hdlh.isActiveLightHouse = false;
  }
}

function* login() {
  const { preventRedirect, previousPath } = yield select(selectRouter);

  if (!preventRedirect) {
    if (previousPath !== '') {
      history.push(previousPath);
      yield put(setRouterPreviousPath(''));
    } else {
      history.push('/dashboard/home');
    }
  }

  if (preventRedirect) {
    yield put(setRouterPreventRedirect(false));
  }

  yield put(setInvitation(null));
}

export default [
  takeLatest(logOut.type, logout),
  takeLatest([logInSuccess.type, authInitSuccess.type], login),
];
